import React from 'react';
import StatisticRow from '../StatisticRow/Row';

interface IProps {
  activeTotal: number;
  total: number;
}

const PractitionerSection = ({ activeTotal, total }: IProps) => {
  return (
    <div className="bg-white rounded-[1rem] py-2 px-3 shadow-primary flex flex-col justify-around bg-practitioner bg-no-repeat bg-right-bottom bg-[length:16.6rem_14.1rem]">
      <StatisticRow title="Total Active Practitioners" value={activeTotal} />
      <StatisticRow title="Total Practitioners" value={total} />
    </div>
  );
};

export default PractitionerSection;
